import { render, staticRenderFns } from "./manual-downgrade.vue?vue&type=template&id=89fa1ce6&"
import script from "./manual-downgrade.vue?vue&type=script&lang=js&"
export * from "./manual-downgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports